import MList from "@material-ui/core/List";
import React, { Component } from "react";
import LoadingCell from "./LoadingCell";
import JumboLoadingCell from "../JumboMenu/LoadingCell";
import Skeleton from "@material-ui/lab/Skeleton";

class LoadingMenu extends Component {
  render() {
    const { settings } = this.props;
    const components = {
      list: LoadingCell,
      jumbo: JumboLoadingCell,
    };
    const Cell = components[settings.store_layout];
    return (
      <div className="pt-3">
        <Skeleton variant="rect" style={{ height: 35 }} />
        <MList
          component="nav"
          aria-label="main mailbox folders"
          style={{
            width: "100%",
            backgroundColor: "white",
            paddingBottom: 8,
            paddingTop: 8,
          }}
        >
          <Cell />
          <Cell />
          <Cell />
          <Cell />
          <Cell />
        </MList>
      </div>
    );
  }
}

export default LoadingMenu;
